// useFreezeCardQuery

import { useQuery } from 'react-query';
import { httpService } from '../../services/http.service';
import { BASE_URL, USER } from '../../constants/endpoints';
import { useStore } from '../../store';
import { getMostRelevantCard } from '../../helpers/cardStatus.helper';

const {
  CONTROLLERS: {
    CARD_FREEZE: {
      VERSION, BASE, LOCK, UNLOCK,
    },
  },
} = USER;

export const useFreezeCardQuery = ({ freeze, onSuccess, onError }: { freeze: boolean, onSuccess?: () => void, onError: () => void }) => {
  const { customerId } = useStore(state => state.currUser());
  const { getPersonalAccount } = useStore(state => state);

  return useQuery(
    'freeze-unfreeze-Card',
    async () => {
      if (!customerId) {
        return null;
      }
      const cardId = getMostRelevantCard(getPersonalAccount().cards)?.cardId;
      const { data } = await httpService.get((`${BASE_URL}/api/${VERSION}/user/${customerId}/${BASE}/${cardId}/${freeze ? LOCK : UNLOCK}`));
      return data;
    },
    {
      cacheTime: 0,
      enabled: false,
      onError: () => onError(),
      onSuccess: () => {
        if (onSuccess) onSuccess();
      },
    },
  );
};
